import type { Role } from "@beacon/core/access"
import type { ReactNode } from "react"

/*
 * Shows a surface only to an Admin, and renders nothing for anyone else, so a Member never sees a
 * control they would be refused. It decides nothing: `role` is the signed-in Member's as `/me`
 * reports it, which the access module decided, and every type here is that module's `Role`.
 *
 * `admits` takes only `"admin"`: a surface every Member may use needs no gate, and the match is
 * exact, so admitting `"member"` would hide it from Admins. Hiding a control does not protect the
 * action behind it; the route it calls must refuse a Member on its own.
 */
export function RoleGate({
  role,
  admits,
  children,
}: {
  role: Role
  admits: Extract<Role, "admin">
  children: ReactNode
}) {
  return role === admits ? <>{children}</> : null
}
